import type { PackageFlightDeparturePageRouteProps } from "@b2bportal/core-packages";
import { usePackageFlightDeparturePageFetch } from "@tenant/packages";
import { usePackageFlightDeparturePageContainer } from "./usePackageFlightDeparturePageContainer";

export const usePackageFlightDeparturePage = (
  props: PackageFlightDeparturePageRouteProps
) => {
  usePackageFlightDeparturePageFetch(props);
  return usePackageFlightDeparturePageContainer();
};
